/* Advertorial countdown bar — vanilla JS, no dependencies.
   Drives every [data-adv-countdown] element. Two modes:
     - fixed:     counts down to data-end-date (ISO datetime)
     - evergreen: rolling per-visitor timer of data-evergreen-hours,
                  persisted in localStorage under data-key
   On expiry: hides the bar or swaps in the expired message per data-on-expire. */
(function () {
  "use strict";

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  function pad(n) {
    return String(n).length < 2 ? "0" + n : String(n);
  }

  // Stored format: {"t": <deadline ms>, "h": <hours setting it was created with>}
  // Older versions stored a bare integer; that parses to a number here and is
  // rejected by the shape check, which forces a one-time fresh cycle.
  function readStored(key) {
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data.t !== "number" || typeof data.h !== "number") return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeStored(key, target, hours) {
    try {
      window.localStorage.setItem(key, JSON.stringify({ t: target, h: hours }));
    } catch (e) {}
  }

  function resolveTarget(el) {
    var mode = el.getAttribute("data-adv-countdown");

    if (mode === "evergreen") {
      var hours = parseFloat(el.getAttribute("data-evergreen-hours"));
      if (isNaN(hours) || hours <= 0) return null;

      // In the theme editor, always show a fresh timer that matches the
      // current setting so edits are visible immediately.
      if (DESIGN_MODE) return Date.now() + hours * 3600000;

      var key = el.getAttribute("data-key") || "adv-countdown";
      var stored = readStored(key);

      // Reuse the stored deadline only if it was created with the same
      // duration setting and hasn't passed yet. Otherwise start a fresh
      // cycle — this is what makes setting changes take effect for
      // returning visitors and what restarts the rolling timer.
      if (stored && stored.h === hours && stored.t > Date.now()) return stored.t;

      var fresh = Date.now() + hours * 3600000;
      writeStored(key, fresh, hours);
      return fresh;
    }

    var iso = el.getAttribute("data-end-date");
    if (!iso) return null;
    var t = new Date(iso).getTime();
    return isNaN(t) ? null : t;
  }

  function handleExpire(el) {
    var onExpire = el.getAttribute("data-on-expire") || "hide";
    if (onExpire === "show_message") {
      var timer = el.querySelector("[data-adv-timer]");
      var msg = el.querySelector("[data-adv-expired]");
      if (timer) timer.hidden = true;
      if (msg) msg.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function render(el, diff) {
    var totalSeconds = Math.floor(diff / 1000);
    var segs = {
      days: Math.floor(totalSeconds / 86400),
      hours: pad(Math.floor((totalSeconds % 86400) / 3600)),
      minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
      seconds: pad(totalSeconds % 60)
    };
    Object.keys(segs).forEach(function (name) {
      var node = el.querySelector('[data-adv-seg="' + name + '"]');
      if (node) node.textContent = segs[name];
    });
  }

  function stop(el) {
    if (el._advInterval) {
      clearInterval(el._advInterval);
      el._advInterval = null;
    }
  }

  function start(el) {
    if (el.getAttribute("data-adv-init") === "1") return;
    el.setAttribute("data-adv-init", "1");

    var target = resolveTarget(el);
    if (target === null) {
      var timer = el.querySelector("[data-adv-timer]");
      if (timer) timer.hidden = true;
      return;
    }

    function tick() {
      // The theme editor replaces section DOM on every setting change;
      // drop intervals that belong to detached elements.
      if (!document.body.contains(el)) {
        stop(el);
        return;
      }
      var diff = target - Date.now();
      if (diff <= 0) {
        render(el, 0);
        handleExpire(el);
        stop(el);
        return;
      }
      render(el, diff);
    }

    tick();
    el._advInterval = setInterval(tick, 1000);
  }

  function init() {
    var els = document.querySelectorAll("[data-adv-countdown]");
    for (var i = 0; i < els.length; i++) start(els[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  if (DESIGN_MODE) {
    document.addEventListener("shopify:section:load", init);
  }
})();